<template>
<div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label>La prestation vendue existe-t-elle déjà ?</label>
                <select  v-model="newDetail" class="form-control">
                    <option disabled value="">----- Veuillez sélectionner -----</option>
                    <option v-for="mainActivity in mainActivities"
                            :value="mainActivity" :key="mainActivity.id">{{ mainActivity.name }}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label>Prestation vendue *</label>
                    <input type="text" class="form-control" name="details__input" v-model="newDetail.name" ref="input"
                    v-on:keypress.enter.prevent="addDetail()" placeholder="Exemple"/>
            </div>
            <div class="col-md-2">
                <label>Quantité *</label>
                <input type="number" class="form-control" min="0" name="details__input" v-model.number="newDetail.quantity" ref="input" v-on:keypress.enter.prevent="addDetail()" value=1 />
            </div>
            <div class="col-md-2">
                <label>Prix unitaire (en €) *</label>
                <input type="number" class="form-control" name="details__input" v-model="newDetail.price" ref="input" v-on:keypress.enter.prevent="addDetail()" placeholder="20" step="0.01" min="0"/>
            </div>
            <div class="col-md-2">
                <a href="javascript:;" class="btn btn-success billingSuccess" id="detail__button" @click.prevent="addDetail()">Valider</a>
            </div>
        </div>
        <input type="hidden" name="detail" :value="this.jsonDetails" id="detail">

        <div id="errors_valid" v-show="errors != false" style="color:red">Veuillez remplir tous les champs du détail d'activité (non nuls).</div>
    </div>
    <table class="table table-striped" v-if="details.length >0">
        <thead>
        <tr>
            <th>Dénomination de l'activité</th>
            <th>Prix (unitaire en euros)</th>
            <th>Quantité</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="detail in details" :key="detail.id">
            <td>{{ detail.name }}</td>
            <td><span class="price" >{{ detail.price }} €</span></td>
            <td>{{ detail.quantity }}</td>
            <td>
                <a href="javascript:;" class="btn-simple-icon btn-danger pull-right" @click="deleteDetail(detail)"><i class="fa fa-trash"></i></a>
                <a href="javascript:;" class="btn-simple-icon pull-right" @click="editDetail(detail)"><i class="fas fa-pencil-alt"></i></a>
            </td>
        </tr>
        </tbody>
    </table>
    <input type="hidden" :value="priceTotal" name="price" />
</div>
</template>

<script>
    export default {
        name: 'billingShortDetailComponent',
        props: ['olddetails', 'officeMainActivities','hasbilling'],
        data () {
            return {
                'mainActivities': Object.assign([], this.officeMainActivities),
                'details': {},
                'jsonDetails': '',
                'newDetail': {
                    'name': '',
                    'quantity': 1,
                    'price': '',
                    'date_debut':'',
                    'date_fin':''
                },
                'errors' : false,
            }
        },
        mounted () {
            if (this.olddetails != undefined) {
                this.details = this.olddetails
                this.jsonDetails = JSON.stringify(this.details)
                if(this.hasbilling){
                    this.editDetail(this.details[0])
                }
            }
        },
        computed: {
            priceTotal(){
                let total = 0
                for (var i = this.details.length - 1; i >= 0; i--) {
                    total += this.details[i].price * this.details[i].quantity
                }
                this.$parent.$emit('update:totalDispatchedPrice', {
                    'type' : 'total',
                    'quantity' : total
                })
                return total
            },
            existActivity(){
                if(this.newDetail.length >0){
                    return true
                }else{}
            }
        },
        watch: {
            jsonDetails: function(val){
                this.$nextTick(function () {
                    $("#detail").trigger('change');
                })
            }
        },
        methods :{
            addDetail() {
                if (this.newDetail.name != '' && this.newDetail.quantity && this.newDetail.price !== '') {
                    this.newDetail.date_debut = new Date().toISOString().slice(0, 10)
                    this.newDetail.date_fin = new Date().toISOString().slice(0, 10)
                    console.log(this.newDetail)
                    this.details.push(this.newDetail)
                    this.$parent.$emit('update-price', this.priceTotal)
                    this.newDetail = {'name': '',
                        'quantity': 1,
                        'price': ''
                        },
                        this.jsonDetails = JSON.stringify(this.details)

                    this.errors = false
                }
                else{
                    this.errors = true
                }

            },
            deleteDetail(detail) {
                this.details.splice(this.details.indexOf(detail), 1)
                this.jsonDetails = JSON.stringify(this.details)
            },
            editDetail(detail) {
                this.newDetail = detail
                this.details.splice(this.details.indexOf(detail), 1)
                this.$refs.input.focus()
            },

    },
    }
</script>

<style lang="css" scoped>
    #detail__button{
        margin: 2.5rem;
    }
</style>
